/**
 * Calculate the distance between two points on the Earth
 * with the Haversine formula.
 * http://www.geodatasource.com/developers/javascript
 */
export function getDistance(lat1, lon1, lat2, lon2, unit = 'K') {
    if (lat1 === lat2 && lon1 === lon2) {
        return 0;
    }
    const radlat1 = (Math.PI * lat1) / 180;
    const radlat2 = (Math.PI * lat2) / 180;
    const theta = lon1 - lon2;
    const radtheta = (Math.PI * theta) / 180;
    let dist = Math.sin(radlat1) * Math.sin(radlat2) +
        Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    if (dist > 1) {
        dist = 1;
    }
    dist = Math.acos(dist);
    dist = (dist * 180) / Math.PI;
    dist = dist * 60 * 1.1515;
    if (unit == 'K') {
        dist = dist * 1.609344;
    }
    else if (unit == 'N') {
        dist = dist * 0.8684;
    }
    return dist;
}
export function validateDateString(dateString) {
    try {
        const date = new Date(dateString);
        const dateRegEx = /^\d{4}-\d{2}-\d{2}$/;
        if (dateRegEx.test(dateString) &&
            date instanceof Date &&
            !isNaN(date.getTime())) {
            return dateString;
        }
    }
    catch (e) {
        console.log(e);
    }
    return '';
}
/* https://www.stefanjudis.com/blog/validate-urls-in-javascript/
May be replaced by URL.canParse() in the future
https://caniuse.com/mdn-api_url_canparse_static
 */
export function isUrlValid(urlString) {
    try {
        new URL(urlString);
        return true;
    }
    catch (e) {
        console.log(e);
        return false;
    }
}
